import type { BasePageConfig } from '@/pageConfig/BasePageConfig';
import ogImage from '@/static/assets/home/og-fr.png';

export const config: BasePageConfig = {
  seo: {
    title: 'Assurance Multirisques Habitation à partir de 4 €/mois | Lemonade',
    metaTitle: 'Assurance Multirisques Habitation à partir de 4 €/mois | Lemonade',
    description:
      "Lemonade offre une assurance multirisques habitation, boostée à l'intelligence artificielle et axée sur l'impact social.",
    ogImage: ogImage.src,
  },
  layout: {
    headerActions: {
      dropdown: {
        logout: 'Déconnexion',
        myAccount: 'Mon Compte',
        settings: 'Réglages',
      },
      CTAs: {
        backToYourQuote: {
          long: {
            singular: 'Retour à mon devis',
            plural: 'Retour à mes devis',
          },
          short: {
            singular: 'DEVIS',
            plural: 'DEVIS',
          },
        },
        checkOurPrices: {
          long: {
            singular: 'Consultez nos prix',
            plural: 'Consultez nos prix',
          },
          short: {
            singular: 'Consultez nos prix',
            plural: 'Consultez nos prix',
          },
        },
      },
    },
  },
};
